/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/** 品质首页背景图配置 */
export const qualityImages = {
  /** 老客-body背景图 */
  autarkyContentBgImage: {
    png: require('./images/autarky_content_bg.png'),
    webp: require('./images/autarky_content_bg.webp'),
  },
  /** 老客-导航栏背景图 */
  autarkyNavbarBgImage: {
    png: require('./images/autarky_navbar_bg.png'),
    webp: require('./images/autarky_navbar_bg.webp'),
  },
  /** 小程序-老客-body背景图 */
  miniMpAutarkyContentBgImage: {
    png: require('./images/mini_mp_adapt_autarky_content_bg.png'),
    webp: require('./images/mini_mp_adapt_autarky_content_bg.webp'),
  },
  /** 臻有钱小程序-老客-导航栏背景图 */
};

/**
 * 无标签首页背景图配置
 */
export const taglessImages = {
  /** 送话费-body背景图 */
  phoneBillContentBgImage: {
    png: require('./images/phone_bill_content_bg.png'),
    webp: require('./images/phone_bill_content_bg.webp'),
  },
  /** 送话费-导航栏背景图 */
  phoneBillNavbarBgImage: {
    png: require('./images/phone_bill_navbar_bg.png'),
    webp: require('./images/phone_bill_navbar_bg.webp'),
  },
  /** 7天单车卡-body背景图 */
  bikeCard7ContentBgImage: {
    png: require('./images/bike_card_7_content_bg.png'),
    webp: require('./images/bike_card_7_content_bg.webp'),
  },
  /** 7天单车卡-导航栏背景图 */
  bikeCard7NavbarBgImage: {
    png: require('./images/bike_card_7_navbar_bg.png'),
    webp: require('./images/bike_card_7_navbar_bg.webp'),
  },
  /** 顺风车券包-body背景图 */
  carpoolCouponPackageContentBgImage: {
    png: require('./images/carpool_coupon_package_content_bg.png'),
    webp: require('./images/carpool_coupon_package_content_bg.webp'),
  },
  /** 顺风车券包-导航栏背景图 */
  carpoolCouponPackageNavbarBgImage: {
    png: require('./images/carpool_coupon_package_navbar_bg.png'),
    webp: require('./images/carpool_coupon_package_navbar_bg.webp'),
  },
  /** 借贷活动-body背景图 */
  loanActivityContentBgImage: {
    png: require('./images/loan_activity_content_bg.png'),
    webp: require('./images/loan_activity_content_bg.webp'),
  },
  /** 借贷活动-导航栏背景图 */
  loanActivityNavbarBgImage: {
    png: require('./images/loan_activity_navbar_bg.png'),
    webp: require('./images/loan_activity_navbar_bg.webp'),
  },
};

/** hybrid模式-品质首页背景图配置 */
export const hybridQualityImages = {
  /** 老客-body背景图 */
  autarkyContentBgImage: {
    png: require('./images/hybrid/autarky_content_bg.png'),
    webp: require('./images/hybrid/autarky_content_bg.webp'),
  },
  /** 老客-导航栏背景图 */
  autarkyNavbarBgImage: {
    png: require('./images/hybrid/autarky_navbar_bg.png'),
    webp: require('./images/hybrid/autarky_navbar_bg.webp'),
  },
};
